module.exports = __webpack_public_path__ + "img/geod_16.c5c4d0a4.jpg";